import { default as finance } from './finance/routes'
import { default as ticket } from './ticket/routes'

export default [
    ...finance,
    ...ticket
]